import React, { useEffect } from 'react';

const usePageTitle = (title: any) => {
  useEffect(() => {
    document.title = title.join('');
  }, [title]);
};

export default function PageTitle({ children }: any) {
  usePageTitle(children.props.children);
  return null;
}
